import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37618f91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message_board" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head_content" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "left_tips" }, "LINKARD"),
  /*#__PURE__*/_createElementVNode("span", null, "留言"),
  /*#__PURE__*/_createElementVNode("div", { class: "right_line" })
], -1))
const _hoisted_3 = { class: "message_board_box" }
const _hoisted_4 = {
  key: 0,
  class: "empty-card"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-card-text" }, [
  /*#__PURE__*/_createElementVNode("div", null, "暂无内容")
], -1))
const _hoisted_6 = { class: "message_board_item_bg" }
const _hoisted_7 = { class: "user_info_bg" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "user_name" }
const _hoisted_10 = { class: "message_content_bg" }
const _hoisted_11 = { class: "message_content_text_bg" }
const _hoisted_12 = { class: "message_time_style" }
const _hoisted_13 = {
  key: 2,
  class: "leave_message_bg"
}
const _hoisted_14 = { class: "leave_message_content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card-container",
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImg})` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_van_image, {
        class: "back_action",
        src: require('../assets/image/white_btn_icon.svg'),
        onClick: _ctx.backToLinkard
      }, null, 8, ["src", "onClick"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isOwn && _ctx.messageBoardList.length == 0 && !_ctx.listLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_van_image, {
                src: require('../assets/image/icon-empty-dark.png')
              }, null, 8, ["src"]),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        (_ctx.isOwn && _ctx.messageBoardList.length != 0)
          ? (_openBlock(), _createBlock(_component_van_pull_refresh, {
              key: 1,
              class: "list-pull-refresh-view",
              modelValue: _ctx.lisrefreshing,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lisrefreshing) = $event)),
              onRefresh: _ctx.listOnRefresh
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading_text: "加载中...",
                  loading: _ctx.listLoading,
                  "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listLoading) = $event)),
                  finished: _ctx.listFinished,
                  onLoad: _ctx.listOnLoad,
                  finished_text: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_grid, {
                      class: "message_board_grid",
                      "column-num": 1,
                      border: false
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageBoardList, (messageItem, index) => {
                          return (_openBlock(), _createBlock(_component_van_grid_item, {
                            class: "message_board_item",
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("img", {
                                    class: "user_head",
                                    src: messageItem.headImg
                                  }, null, 8, _hoisted_8),
                                  _createElementVNode("span", _hoisted_9, _toDisplayString(messageItem.name), 1),
                                  (messageItem.versionIcon)
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 0,
                                        class: "permission_type",
                                        src: require('../assets/image/' + messageItem.versionIcon)
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("span", null, _toDisplayString(messageItem.message), 1)
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(messageItem.messageTime), 1),
                                (messageItem.canGotoCabinet)
                                  ? (_openBlock(), _createBlock(_component_van_button, {
                                      key: 0,
                                      class: "go_to_linkard",
                                      onClick: ($event: any) => (_ctx.goToLinkard(messageItem))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" 前往访问 ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "onLoad"])
              ]),
              _: 1
            }, 8, ["modelValue", "onRefresh"]))
          : (!_ctx.isOwn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_van_field, {
                    ref: "inputfield",
                    modelValue: _ctx.message,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message) = $event)),
                    rows: "12",
                    type: "textarea",
                    autosize: "",
                    placeholder: "请输入留言...",
                    enterkeyhint: "send",
                    onFocus: _ctx.inputFocus,
                    onKeydown: _ctx.handleKeyboard
                  }, null, 8, ["modelValue", "onFocus", "onKeydown"])
                ]),
                _createVNode(_component_van_button, {
                  class: "send_message_button",
                  onClick: _ctx.sendMessageBoardRequest
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 发送 ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createVNode(_component_Loading, null, null, 512), [
      [_vShow, _ctx.listLoading]
    ])
  ], 4))
}